import { StoreMenu } from 'common/types/entities/mongo/storeMenu'
import { StateKey } from 'common/utils/flipState'
import { StoreMenuParams } from 'common/types/params'
import { CommonState } from 'common/types'
import { fetchStoreMenus } from 'common/services/storeMenu'
import { ArrayUtils } from '@shopping/common'

export interface StoreMenuState {
  storeMenus?: StoreMenu[]
  selectedMenu?: StoreMenu
  params: {}
}

const initialState: StoreMenuState = {
  storeMenus: [],
  selectedMenu: null,
  params: {},
}

const FETCH = 'storeMenu/FETCH'
const SET = 'storeMenu/SET'

export const fetchStoreMenuState = (curState: StateKey, params: StoreMenuParams) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const { selectedId } = params
  const storeMenus = await fetchStoreMenus(params)
  let selectedMenu = null
  if (ArrayUtils.isNotEmpty(storeMenus)) {
    selectedMenu = (selectedId && storeMenus.find(menu => menu._id === selectedId)) || storeMenus[0]
  }
  dispatch({
    curState,
    state: {
      storeMenus,
      selectedMenu,
      params,
    },
    type: FETCH,
  })
}

export const setStoreMenu = (curState: StateKey, selectedMenu: StoreMenu) => {
  return {
    curState,
    selectedMenu,
    type: SET,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...state,
        ...action.state,
      }
    case SET:
      return {
        ...state,
        selectedMenu: action.selectedMenu,
      }
    default:
      return state
  }
}

export default reducer
